import React, { useEffect, useState } from 'react';
import { Button, Image, Modal } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';
import './AddMeals.css';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import useRetail from '../../../hooks/useRetail';
import { useBookingData } from '../../../context/BookingDataContext';
import { useData } from '../../../context/DataContext';

const AddMeals = ({ setUpdatedFoodDetails }) => {
    const { dining, setDining } = useData();
    const { setBookingData, bookingData } = useBookingData();
    const [meals, setMeals] = useState([]);
    const [filteredMeals, setFilteredMeals] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const { getDiningData, getCategoryData } = useRetail();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMealsLoaded, setIsMealsLoaded] = useState(false);
    const [categoryData, setCategoryData] = useState(null)
    const visibleMeals = meals.slice(0, 4);

    useEffect(() => {
        const fetchMeals = async () => {
            try {
                let foodData;
                if(dining) {
                    foodData = dining
                }
                if(dining == null || !dining) {
                    foodData = await getDiningData();
                    setDining(foodData)
                }
                const category = await getCategoryData();

                setCategoryData(category)
                if (category?.length > 0 && foodData?.foods) {
                    const previousFoodDetails = bookingData?.updatedFoodDetails?.food || [];
    
                    const formattedMeals = foodData.foods.map((food) => {
                        const matchedCategory = category.find((cat) => cat._id === food.categoryId);
                        
                        const existingMeal = previousFoodDetails.find(
                            (item) => item.foodId === food._id
                        );

                        return {
                            id: food._id,
                            name: food.name,
                            desc: food.desc,
                            type: food.type,
                            price: food.price,
                            image: food.mediaId?.key,
                            count: existingMeal ? existingMeal.count : 0,
                            categoryId: food.categoryId,
                            foodCategory: matchedCategory ? matchedCategory.name : "Unknown",
                        };
                    });
    
                    setMeals(formattedMeals);
                    setFilteredMeals(formattedMeals);
                    setIsMealsLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching meals:", error);
            }
        };
    
        (async () => {
            await fetchMeals();
        })();
    }, []);   

    useEffect(() => {
        if (!isMealsLoaded) return;
     
        const foodDetails = meals
            .filter(meal => meal.count > 0)
            .map(meal => ({
                foodId: meal.id,
                count: meal.count,
                foodName: meal.name,
                foodCategory: meal.foodCategory,
                price: meal.price,
                totalPrice: meal.count * meal.price
            }));
    
        const foodTotal = foodDetails.reduce((sum, item) => sum + item.totalPrice, 0);
        const totalCount = meals.reduce((total, meal) => total + meal.count, 0);
    
        if (foodDetails.length > 0) {
            setUpdatedFoodDetails({
                foodCount: totalCount,
                food: foodDetails,
                foodTotal: foodTotal,
            });
    
            setBookingData((prevData) => ({
                ...prevData,
                updatedFoodDetails: {
                    foodCount: totalCount,
                    food: foodDetails,
                    foodTotal: foodTotal,
                },
            }));
        } else {
            setUpdatedFoodDetails({
                foodCount: 0,
                food: [],
                foodTotal: 0,
            });
    
            setBookingData((prevData) => ({
                ...prevData,
                updatedFoodDetails: {
                    foodCount: 0,
                    food: [],
                    foodTotal: 0,
                },
            }));
        }
    }, [meals, setUpdatedFoodDetails, setBookingData]); 

    const handleCategoryChange = (categoryId) => {
        setSelectedCategory(categoryId);
    };
    
    const handleIncrement = (id) => {
        setMeals(prevMeals =>
            prevMeals.map(meal =>
                meal.id === id ? { ...meal, count: meal.count + 1 } : meal
            )
        );
    };
    
    const handleDecrement = (id) => {
        setMeals(prevMeals =>
            prevMeals.map(meal =>
                meal.id === id && meal.count > 0 ? { ...meal, count: meal.count - 1 } : meal
            )
        );
    };
    const handleShowMore = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (!isMealsLoaded) return;
    
        if (selectedCategory === "All") {
            setFilteredMeals(meals);
        } else {
            const filtered = meals.filter(meal => meal.categoryId === selectedCategory);
            setFilteredMeals(filtered);
        }
    }, [meals, selectedCategory, isMealsLoaded]);
    
    return (
        <Container className='my-5 add-meals-container'>
            <div className='pb-3 text-mob'>
                <h4 className='fs-28 fw-700 text-black'>
                    Add your meals
                </h4>
            </div>
            <Row 
                className='d-flex align-items-center justify-content-center'
                style={{ borderRadius: '24px', backgroundColor: '#FFFF', border: '1px solid #A0A1AB' }}
            >
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='px-0'>
                    <Row className="m-3 pb-3 meal-content" style={{ backgroundColor: '#fff', borderRadius: '16px' }}>
                        {visibleMeals.map((meal, index) => (
                            <Col key={meal.id} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}> 
                                <div className="d-flex align-items-center py-3 booking-border-bottom">
                                    <div className='me-3'>
                                        <Image
                                            src={meal.image}
                                            alt={`${meal.type} icon`}
                                            preview={false}
                                            className='meals-food-img'
                                            style={{ objectFit: 'cover', borderRadius: '16px' }}
                                        />
                                    </div>
                                    <div>
                                        <h5 className="fs-16 fw-600 text-black mb-1">
                                            {meal.name}
                                        </h5>
                                        <p className="fs-14 fw-400 text-black mb-1">
                                            {meal.desc.replace(/<\/?p>/g, "").replace(/<[^>]+>/g, "")}
                                        </p>
                                        <h6 className="fs-18 fw-700 text-black">
                                            ₹{meal.price.toFixed(2)} x {meal.count}
                                        </h6>
                                    </div>
                                    <div 
                                        className="d-flex align-items-center justify-content-end meal-button ms-auto"
                                        style={{ border: "1px solid black", borderRadius: "28px", padding: "5px 20px" }}
                                    >
                                        <span
                                            // onClick={() => handleDecrement(meal.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <MinusOutlined />
                                        </span>
                                        <span className="fw-700 fs-18 p-1 text-black">
                                            {meal.count}
                                        </span>
                                        <span
                                            // onClick={() => handleIncrement(meal.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <PlusOutlined />
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <div className='d-flex justify-content-end mt-3'>
                             <Button
                                type="default"
                                className="fs-16 fw-600 booking-btn"
                                style={{borderColor: '#272727'}}
                                size="large"
                                // onClick={handleShowMore}
                            >
                               Show More
                            </Button>
                        </div>
                    </Row>
                </Col>
            </Row>

            <Modal 
                title='All Meals Item' 
                open={isModalOpen} 
                onCancel={handleCloseModal} 
                footer={null} 
                width={700}
                className='meals-modal'
            >
                <div className='my-3 meal-content'>
                    <Button
                        key="All"
                        type="default"
                        size="large"
                        className={`fs-14 fw-700 booking btn text-${
                            selectedCategory === "All" ? "white" : "black"
                        } m-2`}
                        style={{
                            backgroundColor: selectedCategory === "All" ? "#000" : "transparent",
                            borderColor: "#000",
                            borderRadius: "28px",
                            padding: "0 2rem",
                        }}
                        onClick={() => handleCategoryChange("All")}
                    >
                        All
                    </Button>

                    {categoryData?.map((category) => (
                        <Button
                            key={category._id}
                            type="default"
                            size="large"
                            className={`fs-14 fw-700 booking btn text-${
                                selectedCategory === category._id ? "white" : "black"
                            } m-2`}
                            style={{
                                backgroundColor:
                                    selectedCategory === category._id
                                        ? "#000"
                                        : "transparent",
                                borderColor: "#000",
                                borderRadius: "28px",
                                padding: "0 2rem",
                            }}
                            onClick={() => handleCategoryChange(category._id)}
                        >
                            {category.name}
                        </Button>
                    ))}
                </div>

                <div className="pb-3" style={{ overflowY: 'auto', maxHeight: '400px', overflowX: 'hidden'}}>
                    <Row>
                        {filteredMeals.map((meal) => (
                            <Col key={meal.id} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>                              
                                <div className="d-flex align-items-center py-3 booking-border-bottom">
                                    <div className='me-3'>
                                        <Image
                                            src={meal.image}
                                            alt={`${meal.type} icon`}
                                            preview={false}
                                            className='meals-food-img'
                                            style={{ objectFit: 'cover', borderRadius: '16px' }}
                                        />
                                    </div>
                                    <div>
                                        <h5 className="fs-16 fw-600 text-black mb-1">
                                            {meal.name}
                                        </h5>
                                        <p className="fs-14 fw-400 text-black mb-1">
                                            {meal.desc.replace(/<\/?p>/g, "").replace(/<[^>]+>/g, "")}
                                        </p>
                                        <h6 className="fs-18 fw-700 text-black">
                                            ₹{meal.price.toFixed(2)} x {meal.count}
                                        </h6>
                                    </div>
                                    <div 
                                        className="d-flex align-items-center justify-content-end meal-button ms-auto"
                                        style={{ border: "1px solid black", borderRadius: "28px", padding: "5px 20px" }}
                                    >
                                        <span
                                            // onClick={() => handleDecrement(meal.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <MinusOutlined />
                                        </span>
                                        <span className="fw-700 fs-18 p-1 text-black">
                                            {meal.count}
                                        </span>
                                        <span
                                            // onClick={() => handleIncrement(meal.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <PlusOutlined />
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <div className='d-flex justify-content-end'>
                            <Button
                                type="primary"
                                className="fs-16 fw-600 booking-btn"
                                size="large"
                                onClick={handleCloseModal}
                            >
                                Continue
                            </Button>
                        </div>
                    </Row>
                </div>
            </Modal>
        </Container>
    );
};

export default AddMeals;
